module.exports = __webpack_public_path__ + "static/Объявление2018-2.docx";